import React from 'react';

// Create React App / Webpack: include PNG assets from src/assets/upgrades.
// This path is relative to src/components/Sidebar/UpgradeIcon.jsx.
const iconFiles = require.context('../../assets/upgrades', false, /\.(png|webp|jpe?g)$/i);
const icons = {};
iconFiles.keys().forEach((key) => {
  const filename = key.replace(/^\.\//, '');
  const basename = filename.replace(/\.[^.]+$/, '').toLowerCase();
  const asset = iconFiles(key);
  icons[basename] = asset.default || asset;
});

const normalize = (value) => String(value || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

export const upgradeTier = (id) => {
  const match = /-(\d+)$/.exec(String(id || ''));
  return match ? Number(match[1]) : 0;
};

export const upgradeImage = (id) => {
  const normalized = normalize(id);
  const withoutTier = normalized.replace(/-\d+$/, '');
  const candidates = [normalized, withoutTier, normalized.replace(/-/g, '_'), withoutTier.replace(/-/g, '_')];
  for (const candidate of candidates) {
    if (icons[candidate]) return icons[candidate];
  }
  return null;
};

const UpgradeIcon = ({ id, className = '', style, alt = '', ...props }) => {
  const src = upgradeImage(id);
  if (!src) {
    return (
      <span
        className={className}
        style={{ display: 'inline-grid', placeItems: 'center', fontSize: '1.25rem', ...style }}
        role="img"
        aria-label={alt || `Upgrade ${id}`}
        title={`Missing upgrade icon: ${id}`}
        {...props}
      >
        ♪
      </span>
    );
  }
  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{ objectFit: 'contain', imageRendering: 'pixelated', ...style }}
      draggable={false}
      {...props}
    />
  );
};

export default UpgradeIcon;
